<template>
  <div class="box14">
    <pageTitle title="常见问题" />

    <commomProblem :problemData="problemData" :styleData="styleData" />
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import commomProblem from "../common/commom-problem.vue";
export default {
  components: {
    pageTitle,
    commomProblem,
  },
  data() {
    return {
       problemData: [
        {
          title: "Java程序员转型，走技术管理方向还是架构方向好？",
          answer:[ "3年Java开发经验，技术经理和架构师岗位都有招聘，技术经理岗稍多，两个岗位薪资基本持平；5年经验，同样都有招聘，岗位数量基本持平，但薪资上架构师要高出一截。","所以结论很明朗：架构师发展起来后劲更足，单纯的管理会继续走向瓶颈。"]
           
        },
        {
          title: "狂野架构师变成尊享系列之后，在课程内容上有什么区别？",
          answer:[ "课程内容较之前狂野架构师，增加了项目课程和企业级核心技术点，同时穿插直播串讲形式保证学生的答疑效果，绝对的物超所值。如果错过了之前的狂野架构师，可不能再错过架构师尊享班咯！"]
           
        },
        {
          title: "Java架构师尊享系列是否有入学门槛？",
          answer:[  "尊享系列是博学谷重磅推出的明星就业产品，通过私⼈定制专属学习路径，短时间内即可⾼效完成课程学习，掌握核心技术，因此课程更适合有Java基础经验的同学学习哦，另外保薪学员还需要通过测评。"]
          
        },
        {
          title:
            "Java架构师尊享系列，教学团队和服务和之前的狂野架构师有什么区别？",
          answer:[  "相比之前的狂野系列，我们在教学团队和服务上做了优化和升级，调取了博学谷优质架构师讲师，服务上更加人性化和严谨。"]
          
        },
        {
          title: "学完后达到什么样的水平？",
          answer:["课程对标阿里P7，学完可直接胜任Java架构师。"] 
        },
        {
          title: "提供就业机会或者推荐就业吗？",
          answer:[ "从简历指导、面试到试用期辅导，博学谷提供全套的就业服务，详情请咨询老师。"]
           
        }
      ],
      styleData: {
        iconQuestion: require("../../../assets/coursePage/ai/box17/question.png"),
      },
    };
  },
};
</script>

<style lang="less" scoped>
.box14 {
  padding: 80px 0px 88px;
  width: 100%;
  background-image: linear-gradient(
    -30deg,
    rgba(224, 245, 255, 0.5) 0%,
    rgba(240, 250, 255, 0.5) 18%,
    rgba(255, 255, 255, 0.5) 50%,
    rgba(240, 250, 255, 0.5) 82%,
    rgba(224, 245, 255, 0.5) 100%
  );
}
</style>
